import axios from "axios";
import store from "@/store/store";
import router from "@/router";

let sharedApiClient;

export const apiClient = {
  sharedInstance() {
    if (!sharedApiClient) {
      // Create shared axios instance
      sharedApiClient = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL,
        withCredentials: false,
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        timeout: 30000,
      });

      sharedApiClient.interceptors.response.use(
        response => response,
        async error => {
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            // Remove user from local store when api returns 401
            await store.dispatch("user/logoutWithoutReset").then(() =>
              router.replace({
                name: "login",
                query: {
                  sessionInvalid: true,
                },
              })
            );
          }
          return Promise.reject(error);
        }
      );
    }

    // Set authorization header if user is logged in
    const user = store.getters["user/current"];
    if (user && user.auth) {
      sharedApiClient.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${user.auth}`;
    }

    return sharedApiClient;
  },
};
